import { render, staticRenderFns } from "./m-examen.html?vue&type=template&id=3dba3c21&scoped=true&external"
import script from "./m-examen.js?vue&type=script&lang=js&external"
export * from "./m-examen.js?vue&type=script&lang=js&external"
import style0 from "./m-examen.scss?vue&type=style&index=0&id=3dba3c21&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dba3c21",
  null
  
)

export default component.exports